export default __webpack_public_path__ + "static/media/check-circle.a772f5e4.svg";